import { humanizeToolName } from "./humanize-tool";
import type { CoalescedToolActivity, InsightsTranscriptRow } from "./group-tool-stack";

const EVIDENCE_TOOLS = new Set([
  "analytics_query",
  "inspect_dataset",
  "list_datasets",
  "execute_typescript",
]);

function evidenceDetail(activity: CoalescedToolActivity): string | null {
  const args = activity.args;
  const result = activity.result;
  if (args && typeof args === "object") {
    const a = args as Record<string, unknown>;
    if (typeof a.relation === "string" && a.relation.trim()) return a.relation.trim();
    if (typeof a.queryId === "string" && a.queryId.trim()) return a.queryId.trim();
    if (typeof a.query_id === "string" && a.query_id.trim()) return a.query_id.trim();
    if (typeof a.sql === "string" && a.sql.trim()) {
      const sql = a.sql.trim().replace(/\s+/g, " ");
      return sql.length > 64 ? `${sql.slice(0, 61)}…` : sql;
    }
  }
  if (result && typeof result === "object") {
    const r = result as Record<string, unknown>;
    if (typeof r.relation === "string" && r.relation.trim()) return r.relation.trim();
    if (typeof r.queryId === "string" && r.queryId.trim()) return r.queryId.trim();
  }
  return null;
}

/** Last successful analytics/dataset tool → muted evidence caption under the answer. */
export function deriveEvidenceLine(rows: InsightsTranscriptRow[]): string | null {
  let last: CoalescedToolActivity | null = null;
  for (const row of rows) {
    if (row.type !== "tool-stack") continue;
    for (const a of row.activities) {
      if (a.pending || a.error || a.softRefuse) continue;
      if (!EVIDENCE_TOOLS.has(a.tool)) continue;
      last = a;
    }
  }
  if (!last) return null;
  const detail = evidenceDetail(last);
  const label = humanizeToolName(last.tool);
  return detail ? `Evidence · ${label} · ${detail}` : `Evidence · ${label}`;
}
